"use client";

import { syncLocalStorageToCookie } from "@workspace/ui/lib/theme-sync";
import { useTheme } from "next-themes";
import { useEffect } from "react";
import { normalizeRTheme, type RTheme } from "./themes";

/**
 * Mirrors next-themes (localStorage) into the `axp-theme` cookie so the server
 * can read the preference via `readThemeCookie(cookies())` for `defaultTheme`.
 *
 * localStorage / next-themes is the client source of truth; the cookie is only
 * an SSR mirror. When storage is empty, next-themes already uses the layout's
 * cookie-derived `defaultTheme`.
 */
export function ThemeSync({ fallbackTheme }: { fallbackTheme?: RTheme } = {}) {
  const { setTheme, theme } = useTheme();

  useEffect(() => {
    if (!theme) return;

    const next = fallbackTheme === undefined ? theme : normalizeRTheme(theme, fallbackTheme);
    if (next !== theme) {
      setTheme(next);
    }
    syncLocalStorageToCookie(next);
  }, [fallbackTheme, setTheme, theme]);

  return null;
}
